<template lang="pug">
.card
    .card-content
        .flex.align-items-center.justify-content-between
            h4
                slot
            el-upload.upload-demo(
                :show-file-list='false',
                :on-change='handleChange',
                action='#',
                :auto-upload='false',
                multiple
            )
                el-button(icon='el-icon-upload2 ', type='primary') {{ $t('mensagens.territorio.arquivo.enviar') }}
        el-divider(v-if='options.length > 0')
        div(v-for='(item, index) in options', :key='index')
            el-row.list(type='flex', style='margin-bottom: 15px')
                el-col
                    label
                        | {{
                        |
                        | $t('mensagens.territorio.arquivo.nome')
                        |
                        | }}
                    dl
                        el-link(:href='item?.urlDownload', target='_blank')
                            | {{ item.name }}
                el-col
                    label
                        | {{
                        |
                        | $t('mensagens.territorio.arquivo.tamanho')
                        |
                        | }}
                    dl {{ formatFileSize(item?.arquivo?.size ? item?.arquivo?.size : item?.size ? item?.size : item?.fileSize) }}
                el-col(:span='1')
                    el-button(
                        @click='deleteItem(index)',
                        style='margin: 0px 16px; color: #dc362e',
                        type='text',
                        icon='el-icon-delete'
                    )
</template>
<script>
// import http from '@/utils/http';

export default {
    props: {
        url: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            info: {
                name: '',
                size: '',
                file: {},
                src: ''
            }
        };
    },
    mounted() {
        const val = this.options;
        if (!val) return;
        this.info = {
            name: val?.nomeArquivo,
            size: '',
            file: {},
            src: val?.urlDownload
        };
    },

    methods: {
        handleChange(file) {
            const url = URL.createObjectURL(file.raw);

            const info = {
                name: file.name,
                size: file.size,
                file: file.raw,
                src: url,
                id: file.uid
            };
            this.$emit('add', info);
        },

        deleteItem(index) {
            this.info = {
                name: '',
                size: '',
                file: {},
                src: '',
                id: ''
            };
            this.$emit('delete', index);
        },
        formatFileSize(bytes, decimalPoint) {
            if (bytes === 0) return '0 Bytes';
            var k = 1000;
            var dm = decimalPoint || 2;
            var sizes = [
                'Bytes',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB'
            ];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return (
                parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) +
                ' ' +
                sizes[i]
            );
        }
    }
};
</script>
<style scoped lang="scss">
.list {
    text-align: left;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 5px 15px;

    label {
        color: #183b57;
        font-weight: 500;
    }

    dl {
        color: #3b3b3b;
        font-weight: 600;
        margin-bottom: 0px !important;
    }
}
.card {
    border: 1px solid #e4e7ed;
    border-radius: 4px;

    &-content {
        padding: 20px 15px;
    }
}
</style>
